import { render, staticRenderFns } from "./MobileAppRedirect.vue?vue&type=template&id=6b02406a&"
import script from "./MobileAppRedirect.vue?vue&type=script&lang=ts&"
export * from "./MobileAppRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports